var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectAllUsers } from '@debbie/cortex/dist/users/selectors';
import Errors from '../Errors';
import Loading from '../Loading';
import Modal from '../Modal';
import User from './User';
const UserSelectModal = (props) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const users = useSelector((s) => {
        const allUsers = selectAllUsers(s);
        if (!allUsers)
            return [];
        if (!props.filter)
            return allUsers;
        return allUsers.filter(props.filter);
    });
    return (React.createElement(Modal, { header: props.header, onToggle: props.onClose, maxWidth: "670px" },
        error ? React.createElement(Errors, { errors: [error] }) : null,
        !loading ? (users.map((user) => (React.createElement(UserWrapper, { key: user.id },
            React.createElement(User, { user: user, onClick: (user) => __awaiter(void 0, void 0, void 0, function* () {
                    setLoading(true);
                    try {
                        yield props.onSelect(user);
                        setLoading(false);
                    }
                    catch (err) {
                        console.error(err);
                        setError(err);
                        setLoading(false);
                    }
                }) }))))) : (React.createElement(Center, null,
            React.createElement(Loading, { width: "40px" })))));
};
const UserWrapper = styled.div `
  cursor: pointer;
`;
const Center = styled.div `
  margin: 50px auto 30px;
  text-align: center;
`;
export default UserSelectModal;
//# sourceMappingURL=UserSelectModal.js.map